"use strict";

const globals = {};

function PaymentMethodEditorFactory($q, PaymentMethodPicker, PaymentMethodPrompt, $cart) {
    'ngInject';
    class PaymentMethodEditor {
        constructor() {
            var me = this;
            me.picker = new PaymentMethodPicker();
            me.prompt = new PaymentMethodPrompt();
            //promises
            ['creating', 'created', 'editing', 'edited', 'selecting', 'selected', 'deleting', 'deleted'].forEach(k => {
                me[k] = $q.defer();
                me[k].on = me[k].subscribe = me[k].sub = cb => me[k].promise.finally(null, cb);
            });
        }
        edit(paymentMethod) {
            if (!paymentMethod) paymentMethod = $cart.paymentMethod;
            console.warn('edit(paymentMethod', paymentMethod);
            let picker = this.picker;
            let prompt = this.prompt;
            picker.load(true).then(args => {
                if (picker.total) {
                    picker.open({ current: paymentMethod })
                        .catch(args => {
                            if (args.reason === 'create') {
                                var paymentMethod = {
                                    address : $cart.billingLocation.address,
                                    address2 : $cart.billingLocation.address2,
                                    city : $cart.billingLocation.city,
                                    state : $cart.billingLocation.state,
                                    zip : $cart.billingLocation.zip
                                }
                                prompt.open({ title: 'Create a new payment method...', request: paymentMethod});
                            } else if (args.reason === 'edit') {
                                prompt.open({ title: 'Modify payment method...', request: args.paymentMethod });
                            }
                        });
                } else {
                    console.warn('prompt', prompt);
                    paymentMethod.id = "";
                    paymentMethod.number = "";
                    paymentMethod.encryptedNumber = "";
                    paymentMethod.expirationMonth = "";
                    paymentMethod.expirationYear = "";
                    paymentMethod.securityCode = "";
                    paymentMethod.personName = "";
                    paymentMethod.address = $cart.billingLocation.address;
                    paymentMethod.address2 = $cart.billingLocation.address2;
                    paymentMethod.city = $cart.billingLocation.city;
                    paymentMethod.state = $cart.billingLocation.state;
                    paymentMethod.zip = $cart.billingLocation.zip;
                    prompt.open({ title: 'Create a new payment method...', request: paymentMethod });
                }
            })
        }
    }
    return PaymentMethodEditor;
}

function PaymentMethodEditorDirectiveFactory($parse, PaymentMethodEditor) {
    return {
        restrict: 'EA',
        scope: false,
        link: function (scope, element, attr) {
            var editor = new PaymentMethodEditor();
            attr.onSelected && me.picker.selected.subscribe(args => $parse(attr.onSelected)(scope, args));
            attr.onEdited && me.prompt.edited.subscribe(args => $parse(attr.onEdited)(scope, args));
            attr.onCreated && me.prompt.created.subscribe(args => $parse(attr.onCreated)(scope, args));
            attr.onDeleted && me.picker.deleted.subscribe(args => $parse(attr.onDeleted)(scope, args));
            attr.ngModel && $parse(attr.ngModel).assign(scope, editor);

            var $targets = (attr.clickSelector ? element.find(attr.clickSelector) : element);
            console.info('$targets', $targets);
            $targets.on('click', e => editor.edit(scope.$eval(attr.paymentMethod)));
        }
    }
}

angular.module('emun.cart')
    .factory('PaymentMethodEditor', PaymentMethodEditorFactory)
    .directive('paymentMethodEditor', PaymentMethodEditorDirectiveFactory);